// Warenkorb-Upgrade (neu 26.10.2026). Karte, Preise und Texte rechnet der Shop (snippets/tp-cart-upgrade.liquid),
// die Versand-Leiste ebenso (snippets/cart-progress-bar.liquid). Dieses Skript macht nur den Klick:
// erst das neue Paket in den Korb, dann die alten Paket-Zeilen raus. Hüllen und Versandschutz bleiben drin.
// Vorher suchte das Skript das Hauptprodukt über „ruheanker“ im Handle und erwischte dabei die Hüllen.
(function () {
  if (window.__tpCartUpgrade) return;
  window.__tpCartUpgrade = true;

  var KOPF = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-TP-Upgrade': '1' };

  // 27.10.2026: Markierung „leer“ am Warenkorb immer zum Inhalt passend halten. War der Korb beim Laden leer,
  // behielt der Drawer nach dem Hinzufügen über die Kaufbox die Klasse is-empty, Kopf und Liste blieben versteckt
  // und man sah nur den dunklen Hintergrund. Das alte Skript hatte die Klasse entfernt, beim Umbau am 26.10. fehlte das.
  function leerAbgleich() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    var voll = !!cd.querySelector('.drawer__inner .cart-item');
    if (cd.classList.contains('is-empty') === voll) cd.classList.toggle('is-empty', !voll);
    var liste = cd.querySelector('cart-drawer-items');
    if (liste && liste.classList.contains('is-empty') === voll) liste.classList.toggle('is-empty', !voll);
  }
  function leerBeobachten() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    leerAbgleich();
    new MutationObserver(leerAbgleich).observe(cd, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', leerBeobachten);
  else leerBeobachten();

  function neuZeichnen() {
    if (location.pathname === '/cart') { location.reload(); return Promise.resolve(); }
    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sec) {
        var cd = document.querySelector('cart-drawer');
        if (cd && sec['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
          var neu = doc.querySelector('.drawer__inner');
          var alt = cd.querySelector('.drawer__inner');
          if (neu && alt) alt.innerHTML = neu.innerHTML;
          cd.classList.toggle('is-empty', !!doc.querySelector('cart-drawer.is-empty'));
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sec['cart-icon-bubble']) {
          var doc2 = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
          var inhalt = doc2.querySelector('.shopify-section');
          var ziel = bubble.querySelector('.shopify-section') || bubble;
          if (inhalt) ziel.innerHTML = inhalt.innerHTML;
        }
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-tp-up]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    btn.textContent = 'Moment …';

    var props = {};
    (btn.getAttribute('data-tp-up-farben') || '').split(',').filter(Boolean).forEach(function (f, i) {
      props['Farbe Gerät ' + (i + 2)] = f.trim();
    });
    var geschenk = btn.getAttribute('data-tp-up-geschenk');
    if (geschenk) props['Gratis-Geschenk'] = geschenk;

    var weg = {};
    (btn.getAttribute('data-tp-up-weg') || '').split(',').filter(Boolean).forEach(function (k) { weg[k] = 0; });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: KOPF,
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-tp-up-id'), 10), quantity: 1, properties: props }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        if (!Object.keys(weg).length) return r;
        return fetch('/cart/update.js', { method: 'POST', headers: KOPF, body: JSON.stringify({ updates: weg }) });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('update');
        return neuZeichnen();
      })
      .catch(function () {
        neuZeichnen().catch(function () {});
      });
  });
})();
